import moment from 'moment';
import React from 'react';

function SchedulerDayHeader({ date = new Date() }) {
  const dayText = moment(date).format('ddd');

  return (
    <span
      style={{
        display: 'flex',
        flex: '1 1 auto',
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {dayText}
    </span>
  );
}

export default SchedulerDayHeader;
